// import React from "react";
// import { Link } from "react-router-dom";
// import gray from "../images/gray.JPEG";
// import beige from "../images/beige.JPEG";

// const newProducts = [
//   {
//     id: "gray",
//     name: "PAREΛGON GO RUNNERS GRAY",
//     price: "$1,050 USD",
//     img: gray,
//   },
//   {
//     id: "beige",
//     name: "PAREΛGON GO RUNNERS BEIGE",
//     price: "$1,050 USD",
//     img: beige,
//   },
// ];

// const New = () => {
//   return (
//     <div className="max-w-7xl mx-auto px-6 py-12 font-sans text-center">
//       <h1 className="text-3xl font-bold mb-10 uppercase tracking-wide">New Releases</h1>
//       <div className="flex justify-center">
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-2xl w-full">
//           {newProducts.map((product) => (
//             <Link key={product.id} to={`/product/${product.id}`} className="block text-center">
//               <img
//                 src={product.img}
//                 alt={product.name}
//                 className="w-full h-64 object-contain mb-3"
//               />
//               <p className="text-base font-medium">{product.name}</p>
//               <p className="text-sm font-bold text-gray-800 mt-1">{product.price}</p>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default New;

import React from "react";
import { Link } from "react-router-dom";
import gray from "../images/image/PAREAGON 107.jpg";
// import noir from "../images/noir.JPEG";

const newProducts = [
  {
    id: "gray",
    name: "WHITE PAREΛGON RUNNERS",
    price: "$1,050 USD",
    img: gray,
  },
  // {
  //   id: "noir",
  //   name: "PAREΛGON NOIR OFF WHITE",
  //   price: "$550 USD",
  //   img: noir,
  // },
];

const New = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 font-sans text-center">
      <h1 className="text-3xl font-bold mb-10 uppercase tracking-wide">New Releases</h1>
      <div className="flex justify-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-2xl w-full">
          {newProducts.map((product) => (
            <Link key={product.id} to={`/product/${product.id}`} className="block text-center">
              <img
                src={product.img}
                alt={product.name}
                className="w-full h-64 object-contain mb-3"
              />
              <p className="text-base font-medium">{product.name}</p>
              <p className="text-sm font-bold text-gray-800 mt-1">{product.price}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default New;
